<template>
  <el-table-wrapper :data="interfaceChangeInfo" :columns="columns" :column-default="columnDefault" :pagination="paginationFlag" :show-custom-header="true" :show-search-tool="false">
    <template slot-scope="scope" slot="admin-status">
      <span v-if="scope.row.adminStatus === 1" class="state-normal">UP</span>
      <span v-else-if="scope.row.adminStatus === 2" class="state-abnormal">DOWN</span>
    </template>
    <template slot-scope="scope" slot="oper-status">
      <span v-if="scope.row.operStatus === 1" class="state-normal">UP</span>
      <span v-else-if="scope.row.operStatus === 2" class="state-abnormal">DOWN</span>
    </template>
  </el-table-wrapper>
</template>

<script>
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { convertValueForInterfaceSpeed } from '@/utils/number';

export default {
  name: 'WInterfaceChangeTable',
  props: {
    interfaceChangeInfo: {
      type: Array,
      default: () => ([]),
    },
    paginationFlag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      columns: [
        { prop: 'adminStatus', label: 'Admin 상태', sortable: true, width: '90px', scopedSlot: 'admin-status', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'operStatus', label: 'Oper 상태', sortable: true, width: '90px', scopedSlot: 'oper-status', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'interfaceIndex', label: 'index', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'devicename', label: '물리이름', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'alias', label: '설명 (별칭)', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'macaddress', label: 'MAC 주소', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'speed', label: '속도', sortable: true, width: '90px', formatter: (row, column, value) => convertValueForInterfaceSpeed(value) },
        { prop: 'interfaceDuplex', label: 'Duplex', sortable: true, width: '90px', formatter: this.getTableValueAfterCheckEmpty },
      ],
      columnDefault,
    };
  },
  methods: {
    /**
     * 테이블 데이터 빈값 확인
     * @author kimjy
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/InterfaceChangeTable.vue